import { Alert } from '@/ui/molecules/alert/Alert'

export function NotConnectedView() {
  return <Alert variant="info">You are not connected. Please connect your wallet to perform actions.</Alert>
}
